import React from 'react';
import Joi from 'joi-browser';
import Form from './common/form';
import { getSetting, saveSetting } from '../services/settingService';

class SettingForm extends Form {
  state = {
    data: {
      btcToUsd: '',
      usdToNaira: '',
    },
    errors: {},
  };

  schema = {
    _id: Joi.string(),
    btcToUsd: Joi.number().required().label('BTC2USD Rate'),
    usdToNaira: Joi.number().required().label('USD2NGN Rate'),
  };

  async populateSetting() {
    try {
      const settingId = this.props.match.params.id;
      if (settingId === 'new') return;

      const { data: setting } = await getSetting(settingId);
      this.setState({ data: this.mapToViewModel(setting) });
    } catch (ex) {
      if (ex.response && ex.response.status === 404)
        return this.props.history.replace('/not-found');
    }
  }

  async componentDidMount() {
    await this.populateSetting();
  }

  mapToViewModel(setting) {
    return {
      _id: setting._id,
      btcToUsd: setting.btcToUsd,
      usdToNaira: setting.usdToNaira,
    };
  }

  doSubmit = async () => {
    const { data } = this.state;
    // Call the server

    await saveSetting(data);

    this.props.history.push('/settings');
  };

  render() {
    const settingId = this.props.match.params.id;
    return (
      <div className="row">
        <div className="col-md-6 offset-md-3" style={{ marginTop: 50 + 'px' }}>
          <div className="text-center">
            <h4
              className="h4 mb-2 login-welcome-text"
              style={{ marginTop: 20 + 'px', fontWeight: 'bold' }}
            >
              Exchange Rate Setting Form
            </h4>
            <p style={{ color: '#000524' }}>
              This operation can only be performed by Jeroid Admin
            </p>
          </div>
          <div
            className="card card-register mx-auto mt-2"
            style={{ border: 0, borderRadius: 0, marginBottom: 10 + '%' }}
          >
            <div
              className="card-header"
              style={{
                backgroundColor: 'white',
                borderBottom: 0,
                marginTop: 2 + '%',
                fontWeight: 'bold',
              }}
            >
              Settings Info
            </div>
            <hr
              style={{
                marginRight: 20 + 'px',
                marginLeft: 20 + 'px',
                marginTop: 0,
                marginBottom: 0,
              }}
            />
            <div className="card-body">
              <form onSubmit={this.handleSubmit}>
                <div className="form-row">
                  <div className="col-md-6">
                    {this.renderInput(
                      'btcToUsd',
                      'BTC2USD Rate',
                      '',
                      'autofocus',
                      'number'
                    )}
                  </div>
                  <div className="col-md-6">
                    {this.renderInput(
                      'usdToNaira',
                      'USD2NGN Rate',
                      '',
                      '',
                      'number'
                    )}
                  </div>
                </div>

                <div className="text-center">
                  {settingId === 'new'
                    ? this.renderButton('Save')
                    : this.renderButton('Update')}
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default SettingForm;
